import { useState } from "react";
import { useErrorTabCount } from "src/Hooks/useErrorTabCount";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  IMarketmakingTradeTableSearchParams,
  MarketmakingTableTabs,
} from "../../../Interfaces/marketmaking";
import MarketmakingOrderTable from "../../../Tables/Marketmaking/Order/Table";
import { getMarketmakingErrorsTable } from "../../../Requests/marketmaking";
import ErrorsTable from "../../../Tables/Order/ErrorsTable/ErrorsTable";
import MarketmakingTradeTable from "../../../Tables/Marketmaking/Trade/TradeTable";
import TabBox from "../../../Components/Tabbox/TabBox";
import { setMarketmakingTabIndex } from "../../../Features/Marketmaking/marketmakingSlice";
import Program from "./Program";

const TablesWrapper = () => {
  const tabIndex = useAppSelector((store) => store.marketmaking.tabIndex);
  const taskTableClickedRowValues = useAppSelector(
    (store) => store.marketmaking.clickedTaskTableRowValues
  );
  const dispatch = useAppDispatch();

  const { errorTabCount, errorTableRefreshFlag, errorTableAfterFetchHandler } =
    useErrorTabCount(
      "marketmaking",
      tabIndex,
      MarketmakingTableTabs.ErrorsTable,
      getMarketmakingErrorsTable
    );

  const [searchParams, setSearchParams] = useState(
    {} as IMarketmakingTradeTableSearchParams
  );

  const getTable = () => {
    switch (tabIndex) {
      case MarketmakingTableTabs.Program:
        return <Program />;

      case MarketmakingTableTabs.OrderTable:
        return (
          <MarketmakingOrderTable
            searchParam={{ taskId: taskTableClickedRowValues?.id }}
          />
        );

      case MarketmakingTableTabs.TradeTable:
        return (
          <MarketmakingTradeTable
            searchParam={{
              ...searchParams,
              taskId: taskTableClickedRowValues?.id,
            }}
          />
        );

      case MarketmakingTableTabs.ErrorsTable:
        return (
          <ErrorsTable
            getData={getMarketmakingErrorsTable}
            searchParams={searchParams}
            onFetchComplete={errorTableAfterFetchHandler}
            refreshFlag={errorTableRefreshFlag}
          />
        );
    }
  };

  const tablesTabsChildren = [
    { index: MarketmakingTableTabs.OrderTable, title: "سفارشات" },
    { index: MarketmakingTableTabs.TradeTable, title: "معاملات" },
    {
      index: MarketmakingTableTabs.ErrorsTable,
      title: "خطا",
      count: errorTabCount,
    },
  ];

  const getTableTabChildren = () => {
    if (taskTableClickedRowValues && taskTableClickedRowValues.id)
      return [
        { index: MarketmakingTableTabs.Program, title: "تنظیمات ارسال" },
        ...tablesTabsChildren,
      ];
    return tablesTabsChildren;
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 border border-gray-300 rounded w-full p-3 h-full">
      <div className="max-w-min ml-5">
        <TabBox
          activeTab={tabIndex}
          children={getTableTabChildren()}
          onChange={(_, index) => dispatch(setMarketmakingTabIndex(index))}
        />
      </div>
      {getTable()}
    </div>
  );
};

export default TablesWrapper;
